import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { getColorHexStringFromCapacityRatio } from '../../../../../capacityColors';
import { RootState } from '../../../../../store';
import { getActiveColorByOption } from '../../../../../store/selectors/getColorFromMemberDefinitionSelector';
import { getHighestCapacityForItem } from '../../../../../store/selectors/getHighestCapacityForItemSelector';
import { DisplayNameProviderProps } from './PrimaryRowText';

interface ItemWithType {
  guid: string;
  name: string;
  type: string;
}

type OwnProps = DisplayNameProviderProps<ItemWithType>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = OwnProps & StateProps;

const getColor = (props: Props): string => {
  if (props.heatmapType === 'None') {
    return 'white';
  }

  if (props.heatmapType === 'Combined' && props.highestCapacityForItem) {
    return getColorHexStringFromCapacityRatio(props.highestCapacityForItem);
  }

  return 'white';
};

const ColoredName: FunctionComponent<Props> = (props) => (
  <Box component="span" sx={{ color: getColor(props) }}>
    {props.displayName}
  </Box>
);

const mapStateToProps = (state: RootState, props: OwnProps) => {
  const colorBy = getActiveColorByOption(state);

  return {
    heatmapType: colorBy === 'Combined' ? colorBy : 'None',
    analysisSetGuid: state.analysisSets.activeAnalysisSetGuid,
    highestCapacityForItem: getHighestCapacityForItem(state, props.row.item.guid, props.row.item.type),
  };
};

export default connect(mapStateToProps)(ColoredName);
